enum ContractType {
  TOWCON2008 = "TOWCON2008",
  SUPPLYTIME2017 = "SUPPLYTIME2017",
}

export default ContractType;